/**
 * Constants
 *
 * @description general constants
 */
export const Constants = {
  MOCK_FLAG: 'mockRequest',
  NEW_URL_COMPLAINT_BOOK: '/complaint-book',
  GENERAL_ERROR_ILUSTRATION: 'generalErrorDisabled1Medium',
};
